module.exports = __webpack_public_path__ + "static/media/prawns-creamy-marnier-uncropped.80adb642.png";